import { checkCreditAuthorization } from './client';
import { useEffect, useState } from 'react';
import { useCredits } from './CreditsProvider';
import Raven from 'raven-js';
export function useCreditCheck({
  action,
  creditsNeeded,
  numberOfOperations
}) {
  const {
    creditsPolicy
  } = useCredits();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasHubspotCredits = creditsPolicy.hubspotCredits();
  const hasUserLoaded = creditsPolicy.user.isLoaded;
  const operations = creditsNeeded || numberOfOperations || 0;
  useEffect(() => {
    if (!hasUserLoaded) {
      return;
    }

    /**
     * @todo Remove this once hubspot credits are ungated
     */
    if (!hasHubspotCredits) {
      setIsAuthorized(true);
      setIsLoading(false);
      return;
    }
    if (operations < 0) {
      setIsAuthorized(false);
      setIsLoading(false);
      return;
    }
    setError(null);
    checkCreditAuthorization({
      action,
      numberOfOperations: operations
    }).then(({
      authorized
    }) => {
      setIsAuthorized(authorized);
    }).catch(err => {
      setError(err instanceof Error ? err : new Error('Failed to check credit authorization'));
      Raven.captureException(err, {
        extra: {
          action,
          numberOfOperations: operations
        }
      });
      setIsAuthorized(false);
    }).finally(() => {
      setIsLoading(false);
    });
  }, [action, operations, hasHubspotCredits, hasUserLoaded]);
  return {
    isAuthorized,
    hasError: !!error,
    isLoading
  };
}